// Floating score text, shredded-paper particles, and torn ticket halves.
import { G } from '../game/state';
import type { Entity } from '../game/types';

export function addText(x: number, y: number, str: string, color?: string, big?: boolean): void {
  G.texts.push({ x, y, str, color: color || '#fff', life: 1, big: !!big });
}

export function shred(x: number, y: number, color: string, n: number): void {
  for (let i = 0; i < n; i++)
    G.parts.push({
      x,
      y,
      vx: (Math.random() - 0.5) * 9,
      vy: -Math.random() * 7 - 1,
      g: 0.3,
      life: 0.8 + Math.random() * 0.5,
      color,
      w: 3 + Math.random() * 5,
      h: 6 + Math.random() * 8,
      rot: Math.random() * 6,
      vr: (Math.random() - 0.5) * 0.4,
    });
}

// Two torn halves that peel apart from a sliced card.
export function cardHalves(o: Entity, color: string): void {
  const a = Math.random() * 0.6 - 0.3;
  for (const s of [-1, 1])
    G.halves.push({
      x: o.x,
      y: o.y,
      vx: o.vx + s * 3,
      vy: o.vy - 2,
      r: o.r,
      rot: (o.rot || 0) + a,
      vr: s * 0.15,
      side: s,
      color,
      life: 1.2,
      prio: o.prio,
    });
}
